export default class clsStopwatch{
	constructor(){
		this.startAt = 0;
        this.lapTime = 0;
        this.timer = false;
	}

	get startTimer(){
		return this.startAt;
    }

	now() {
        return(new Date()).getTime();
    }

    start() {
        this.timer = true;
        this.startAt = this.startAt ? this.startAt : this.now();
    }

    stop() {
        // If running, update elapsed time otherwise keep it
		this.lapTime = this.startAt ? this.lapTime + this.now() - this.startAt : this.lapTime;
        this.startAt = 0; // Paused
        this.timer = false;
    }

    reset() {
        this.lapTime = this.startAt = 0;
        this.timer = false;
    }

    time() {
        return this.lapTime + (this.startAt ? this.now() - this.startAt : 0);
	}
 }